<template>
  <b-card :title="cardTitle">
    <b-list-group>
      <donation-group />
      <bank-account />
      <safe-account />
      <donate-date />
      <is-receipt v-if="!dataItem.id_bank_accounts" />
      <notes-text />
      <amount />
    </b-list-group>
  </b-card>
</template>
<script>
import {
  BCard, BListGroup,
} from 'bootstrap-vue'
import DonationGroup from '@/views/Admin/Account_activities/Incomes/PreviewCard/DonationGroup.vue'
import BankAccount from '@/views/Admin/Account_activities/Incomes/PreviewCard/BankAccount.vue'
import SafeAccount from '@/views/Admin/Account_activities/Incomes/PreviewCard/SafeAccount.vue'
import DonateDate from '@/views/Admin/Account_activities/Incomes/PreviewCard/DonateDate.vue'
import NotesText from '@/views/Admin/Account_activities/Incomes/PreviewCard/Notes.vue'
import IsReceipt from '@/views/Admin/Account_activities/Incomes/PreviewCard/IsReceipt.vue'
import Amount from '@/views/Admin/Account_activities/Incomes/PreviewCard/Amount.vue'

export default {
  name: 'PreviewCard',
  components: {
    BCard,
    BListGroup,
    DonationGroup,
    BankAccount,
    SafeAccount,
    DonateDate,
    NotesText,
    IsReceipt,
    Amount,
  },
  props: {
    cardTitle: {
      type: String,
      default: '',
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
  },
}
</script>
